<template>
  <form @submit.prevent>
    <div>
      <h2>
        <span v-if="isEditMode">"{{ editedEntity.name | translate | summary(150) }}" {{ $t("common.update") }}</span>
        <span v-else>{{ $t("processing-transfering.legal-reason.new") }}</span>
      </h2>

      <b-form-tags v-model="form.products" size="lg" class="mb-2" add-on-change no-outer-focus>
        <template v-slot="{ tags, inputAttrs, inputHandlers, disabled, removeTag }">
          <b-form-select v-bind="inputAttrs" v-on="inputHandlers" :disabled="disabled || products.length === 0" :options="products">
            <template #first>
              <!-- This is required to prevent bugs with Safari -->
              <option disabled value=""> {{ $t("product.text") }}</option>
            </template>
          </b-form-select>

          <ul v-if="tags.length > 0" class="list-inline d-inline-block mt-2">
            <li v-for="tag in tags" :key="tag" class="list-inline-item">
              <b-form-tag @remove="removeTag(tag)" :title="tag" :disabled="disabled" variant="primary">{{ tag }}</b-form-tag>
            </li>
          </ul>
          <b-form-text v-else>
            <span class="text-danger">{{ $t("product.required") }}</span>
          </b-form-text>
        </template>
      </b-form-tags>

      <label>{{ $t("processing-transfering.legal-reason.name") }}</label>
      <textarea
        style="color:#495057;"
        @input="$v.form.name.$touch()"
        :class="['w-100', 'form-control', $v.form.name.$invalid ? 'is-invalid' : 'is-valid']"
        v-model="form.name"
        rows="5"
      ></textarea>

      <div v-if="form.products && form.products.includes('GDPR')" class="mt-3">
        <sweet-input
          v-model="form.gdprRegulation"
          :isValid="!$v.form.gdprRegulation.$error"
          @input="$v.form.gdprRegulation.$touch()"
          layout="vertical"
          :placeholder="$t('common.name')"
          :label="$t('common.regulation-gdpr')"
        />
      </div>

      <div v-if="form.products && form.products.includes('KVKK')" class="mt-3">
        <sweet-input
          v-model="form.kvkkRegulation"
          :isValid="!$v.form.kvkkRegulation.$error"
          @input="$v.form.kvkkRegulation.$touch()"
          layout="vertical"
          :placeholder="$t('common.name')"
          :label="$t('common.regulation-kvkk')"
        />
      </div>

      <sweet-button @click="save()" type="submit" :loading="isUpdating" :disabled="isUpdating || $v.$invalid" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
        {{ $t("common.save") }}
      </sweet-button>
    </div>
  </form>
</template>
<script>
import { maxLength, minLength, required } from "vuelidate/lib/validators";

const state = "workspaceLegalReason";

export default {
  props: {
    closeOnSave: { type: Boolean, default: true },
  },
  data() {
    return {
      form: { name: undefined, gdprRegulation: undefined, kvkkRegulation: undefined },
      formError: undefined,
    };
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(1),
        maxLength: maxLength(1500),
      },
      products: {
        validate() {
          return (this.form.products && this.form.products.length > 0) || false;
        },
      },
      gdprRegulation: {
        validateRegulation() {
          if (this.form.products?.includes("GDPR")) {
            return !!this.form.gdprRegulation;
          }
          return true;
        },
      },
      kvkkRegulation: {
        validateRegulation() {
          if (this.form.products?.includes("KVKK")) {
            return !!this.form.kvkkRegulation;
          }
          return true;
        },
      },
    },
  },
  watch: {
    editedEntity: {
      deep: true,
      immediate: true,
      handler(v) {
        this.form = { ...this.prepareFormForEdit(v) };
      },
    },
  },
  computed: {
    isUpdating() {
      return this.$store.getters[`${state}/isUpdating`];
    },
    editedEntity() {
      return this.$store.getters[`${state}/editedEntity`];
    },
    isEditMode() {
      return this.$store.getters[`${state}/isEditMode`];
    },
  },
  mounted() {},
  methods: {
    async save() {
      const ok = await this.confirm(this.$t(`alert.approve`));
      if (!ok) {
        return;
      }
      try {
        const { data } = await this.$store.dispatch(`${state}/save`, this.form);
        this.form = {};
        this.$toast.success(this.$t("common.success"));
        if (this.closeOnSave) {
          this.$root.$emit("bv::toggle::collapse", "sidebar-new-processing-transfering-legal-reason");
        }
        setTimeout(() => this.$emit("onFormSave", data), 500);
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
  },
};
</script>
